<template>
    <div class="ku-order-out-show">
        <div class="top">
            <div class="left">订单配送</div>
        </div>
        <div class="detail">

            <div class="goods">
                <div class="goods_for" v-for="(v, i) in item.goods" :key="i">
                    <div class="name">
                        <div class="c1">
                            <span>{{v.goods_name}} {{v.num}}份 {{ v.price }}元</span>
                            <label v-for="(v1, k1) in v.raise_arr" :key="k1">*{{v1[1]}}</label>
                        </div>
                        <div class="c2" v-if="v.type === 'combo'">
                            <div class="combo" v-for="(v1, k1) in v.item" :key="k1">
                                <span>*{{v1.goods_name}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="address">

                <!-- 寄件人 -->
                <div class="item item-1">
                    <div class="icon">
                        <span>寄</span>
                    </div>
                    <div class="value">
                        <label class="value-name">{{ item.shop.shop_name }} {{ item.shop.mobile }}</label>
                        <label class="value-address">{{ item.shop.address }}</label>
                    </div>
                </div>
            </div>

            <div class="address">
                <!-- 收件人 -->
                <div class="item">
                    <div class="icon">
                        <span>收</span>
                    </div>
                    <div class="value">
                        <label class="value-name">{{ item.name }} {{ item.mobile }}</label>
                        <label class="value-address">{{ item.province }} {{ item.address }}</label>
                        <label class="value-copy" @click="onCopy()">复制地址</label>
                    </div>
                </div>

            </div>

            <div class="preaddorder" v-if="preaddorder.est_fee > 0">

                <div class="service_trans">
                    <span>配送方式：</span>
                    <span>{{ preaddorder.service_trans_id === 'DADA' ? '达达' : '顺丰' }}</span>
                </div>
                <div class="service_trans">
                    <span>配送距离：</span>
                    <span>{{ preaddorder.distance }}米</span>
                </div>
                <div class="service_trans">
                    <span>预估费用：</span>
                    <span>{{ preaddorder.est_fee / 100 }}元</span>
                </div>

            </div>

            <div class="preaddorder" v-if="item.express">

                <div class="service_trans">
                    <span>订单状态：</span>
                    <span>{{ item.express.order_status_text }}</span>
                </div>

                <div class="service_trans">
                    <span>配送方式：</span>
                    <span>{{ item.express.service_trans_id === 'DADA' ? '达达' : '顺丰' }}</span>
                </div>

                <div class="service_trans">
                    <span>配送距离：</span>
                    <span>{{ item.express.distance }}米</span>
                </div>
                <div class="service_trans">
                    <span>实际支付费用：</span>
                    <span>{{ item.express.actualfee / 100 }}元</span>
                </div>

                <div class="service_trans">
                    <span>违约金：</span>
                    <span>{{ item.express.deductfee / 100 }}元</span>
                </div>

                <div class="service_trans">
                    <span>运力配送单号：</span>
                    <span>{{ item.express.waybill_id }}</span>
                </div>

                <div class="service_trans">
                    <span>取货序号：</span>
                    <span>{{ item.express.order_seq }}</span>
                </div>

                <div class="service_trans">
                    <span>发单时间：</span>
                    <span>{{ item.express.create_time_text }}</span>
                </div>

                <div class="service_trans">
                    <span>预期送达时间：</span>
                    <span>{{ item.express.expected_finish_time_text }}</span>
                </div>

                <div class="service_trans">
                    <span>接单时间：</span>
                    <span>{{ item.express.accept_time_text }}</span>
                </div>

                <div class="service_trans">
                    <span>取货时间：</span>
                    <span>{{ item.express.fetch_time_text }}</span>
                </div>

                <div class="service_trans">
                    <span>送达时间：</span>
                    <span>{{ item.express.finish_time_text }}</span>
                </div>

                <div class="service_trans">
                    <span>取消时间：</span>
                    <span>{{ item.express.cancel_time_text }}</span>
                </div>

                <div class="service_trans">
                    <span>配送员：</span>
                    <span>{{ item.express.transporter_info.transporter_name }}({{ item.express.transporter_info.transporter_phone }})</span>
                </div>

            </div>

            <div class="but">
                <van-button type="primary" v-if="!item.express" size="small" @click="onPrice()">获取价格</van-button>
                <van-button type="primary" v-if="!item.express" size="small" @click="onAddOrder()">下单</van-button>
                <van-button type="primary" v-if="item.express" size="small" @click="onQueryOrder()">更新订单</van-button>
                <van-button type="primary" v-if="item.express && !item.express.finish_time" size="small" @click="onCancelOrder()">取消订单</van-button>
            </div>

        </div>

        <FootTab :tab-key="tabKey"></FootTab>
    </div>
</template>

<script>
import Vue from 'vue';
import {List, Col, Row, Cell, CellGroup, Search, Dialog} from 'vant';
import FootTab from '@/components/foot'
import {setShop, getShop} from '@/utils/auth'

Vue.use(List).use(Col).use(Row).use(CellGroup).use(Cell).use(Search).use(Dialog);
    export default {
        name: "index",
        data() {
            return {
                tabKey: 'out_order',
                item: {},
                shop_id: 0,

                user_name: '',
                user_id: 0,
                preaddorder: {},
            }
        },
        components: {
            FootTab
        },
        computed: {
            id() {
                return this.$route.query.id
            }
        },
        mounted() {
            this.shop_id = getShop();
            console.log(this.shop_id)
            this.getInfo()
        },
        methods: {
            getInfo () {
                // 异步更新数据
                let that = this;
                that.$API.getOutInfo({
                    id: that.id,
                }).then(res => {
                    this.item = res.data;
                    if (this.shop_id != res.data.shop_id) {
                        setShop(res.data.shop);
                    }
                }).catch(err => {
                    Dialog.alert({
                        title: '错误',
                        message: err.msg,
                    }).then(() => {
                        this.$router.push({path: '/out_order'})
                    });
                })
            },
            onUser(item) {
                if (item.user_id > 0) {
                    this.user_name = item.user.nickname
                    this.user_id = item.user_id
                    this.page = 0
                    this.list = []
                    this.finished = false
                    this.loading = true;
                    this.onLoad()
                }
            },
            onPrice() {
                let that = this;
                that.$API.getPreaddorder({
                    id: that.id,
                }).then(res => {
                    this.preaddorder = res.data;
                })
            },
            onAddOrder() {
                let that = this;
                that.$API.getAddOrder({
                    id: that.id,
                }).then(() => {
                    this.getInfo();
                })
            },
            onQueryOrder() {
                let that = this;
                that.$API.getQueryOrder({
                    id: that.id,
                }).then(() => {
                    this.getInfo();
                })
            },
            onCancelOrder() {
                let that = this;
                // 弹出确认框
                Dialog.confirm({
                    title: '标题',
                    message: '确认取消订单吗？需要支付违约金',
                })
                .then(() => {
                    that.$API.getCancelOrder({
                        id: that.id,
                    }).then(() => {
                        this.getInfo();
                    })
                })
                .catch(() => {
                    // on cancel
                });

            },
            async onCopy() {
                try {
                    let textToCopy = this.item.name + ' ' + this.item.mobile + ' \n' + this.item.province + this.item.address;
                    await navigator.clipboard.writeText(textToCopy);
                    this.copied = true;
                    // 可选：一段时间后清除提示
                    setTimeout(() => {
                        this.copied = false;
                    }, 2000); // 2秒后清除提示
                } catch (err) {
                    console.error('复制失败:', err);
                    // 可以在这里处理错误，比如给用户一个错误提示
                    alert('复制失败，请检查浏览器支持情况或尝试手动复制。');
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    .ku-order-out-show {
        margin-bottom: 100px;
        padding-bottom: 100px;
        background: #e3e3e3;
        .detail {
            text-align: left;
            .goods {
                background: #fff;
                margin: 15px;
                padding: 10px;
                border-radius: 15px;

                .goods_for {
                    line-height: 40px;
                    padding: 3px 10px;
                    .c1 {
                        label {
                            display: block;
                            text-indent: 30px;
                        }
                    }
                }
            }

            .address {
                background: #fff;
                margin: 25px 15px;
                padding: 10px;
                border-radius: 15px;
                .item {
                    display: flex;
                    flex-direction: row;
                    .icon {
                        width: 140px;
                        span {
                            display: block;
                            width: 50px;
                            height: 50px;
                            line-height: 50px;
                            text-align: center;
                            background: blue;
                            color: #fff;
                            border-radius: 50%;
                            font-size: 26px;
                            margin: 20px auto;
                        }
                    }
                    .value {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        position: relative;
                        .value-name {
                            font-size: 26px;
                            line-height: 50px;
                        }
                        .value-address {
                            font-size: 24px;
                            line-height: 40px;
                        }
                        .value-copy {
                            position: absolute;
                            right: 0;
                            top: 0;
                            font-size: 24px;
                            line-height: 50px;
                            color: blue;
                        }
                    }
                }
                .item-1 {
                    .icon {
                        span {
                            background: #4fc08d;
                        }
                    }
                }
            }

            .preaddorder {
                background: #fff;
                margin: 25px 15px;
                padding: 10px;
                border-radius: 15px;
                .service_trans {
                    line-height: 60px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    padding: 0 30px;
                    span {
                        font-size: 26px;
                        color: #000;
                    }
                }
            }

            .but {
                margin: 25px 15px;
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                /deep/ .van-button {
                    margin-left: 20px;
                    border-radius: 10px;
                }
            }
        }

        .top {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            background: #4fc08d;
            .left {
                line-height: 60px;
                font-size: 26px;
                padding-left: 20px;
                color: white;
            }
            .van-search {
                padding: 0 12px;
                .van-cell {
                    padding: 0;
                }
            }
        }
        .user_name {
            font-size: 26px;
            line-height: 50px;
        }
        .food-list {
            line-height: 50px;
            border-bottom: 2px solid #BAE2CD;
            .van-col {
                font-size: 24px;
                padding: 0 5px;
                text-align: left;
                &.br-1 {
                    border-top: 2px dashed #000;
                }

                &.active {
                    color: #DD5928;
                }
            }
            &.active {
                background: #ddd;
            }
            .right {
                span {
                    text-align: right;
                    display: block;
                }
            }
            .goods_for {
                .c1 {
                    label {
                        display: block;
                        line-height: 30px;
                        text-indent: 30px;
                    }
                }
            }
        }
        .food-edit {
            width: 100%;
            height: 90%;
            background: #898888;
            .top {
                padding: 40px 20px;
                width: 100%;
                height: 160px;
                .top-left {
                    width: 160px;
                    float: left;
                    /deep/ .van-uploader__preview {
                        .van-image {
                            width: 140px;
                            height: 140px;
                        }
                    }
                }
                .top-right {
                    width: 540px;
                    float: left;
                    .s1 {
                        width: 100%;
                        float: left;
                        .van-field {
                            width: 400px;
                            float: left;
                        }
                        .van-checkbox {
                            font-size: 26px;
                            margin-top: 20px;
                            float: right;
                            /deep/ .van-checkbox__icon {
                                background: #fff;
                            }
                            /deep/ .van-checkbox__label {
                                color: #fff;
                            }
                        }
                    }
                    .van-button {
                        width: 100px;
                        font-size: 24px;
                        padding: 0;
                        margin-right: 10px;
                        margin-top: 10px;
                        border-radius: 10px;
                        height: 50px;
                        background: #AAABAA;
                        border-color: #AAABAA;
                        color: #fff;
                        &:nth-child(6) {
                            margin-right: 0;
                        }
                        &.active {
                            background: #1E9B8E;
                            border-color: #1E9B8E;
                        }
                    }
                }
            }
            .center {
                width: 98%;
                margin: 0 auto;
                .van-field {
                    /deep/ .van-field__label {
                        width: 120px;
                    }
                }
                .max {
                    width: 100%;
                    position: relative;
                    min-height: 80px;
                    .van-field {
                        width: 50%;
                        height: 80px;
                        float: left;
                    }
                }
            }
            .foot-raise {
                text-align: left;
                padding: 30px 10px;
                .van-button {
                    width: 138px;
                    font-size: 24px;
                    padding: 0;
                    margin-right: 8px;
                    margin-top: 20px;
                    border-radius: 10px;
                    height: 50px;
                    background: #FFF;
                    border-color: #FFF;
                    &.active {
                        background: #1E9B8E;
                        border-color: #1E9B8E;
                        color: #fff;
                        span > span {
                            color: #C6D739;
                        }
                    }
                }
            }
            .foot-category {
                .van-button {
                    background: none;
                    color: #fff;
                }
            }
            .ku-submit {
                width: 60%;
                margin: 0 auto;
                text-align: center;
            }
        }
        .add-button {
            width: 310px;
            margin-top: 30px;
        }
    }

</style>
